import OrderBookSamplingTable from "../../Tables/OrderBookSampling/OrderBookSamplingTable";

const OrderBook = () => {
  return <OrderBookSamplingTable />;
};

export default OrderBook;
